import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { BasicFlex } from '../../Common';

const LegendList = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(3, auto);
  grid-auto-columns: 20rem;
  gap: 2.5rem 1.5rem;
  align-items: start;
  margin-left: 2rem;
  flex: 1;
  min-width: 0;
`;

const LegendRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: .75rem;
  cursor: pointer;
  min-width: 0;
  &:hover {
    opacity: 0.75;
  }
`;

const Swatch = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background-color: ${props => props.color};
  flex-shrink: 0;
`;

const LabelBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
  font-size: 1.3rem;
  min-width: 0;
  flex: 1;
`;

const Title = styled.div`
  color: ${props => props.theme.colors.mildText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Subheader = styled.div`
  font-size: 1.2rem;
`;

const DEFAULT_COLORS = ['#02B2AF', '#2E96FF', '#B800D8', '#60009B', '#2731C8', '#03008D'];

const revenueData = [
  { id: 0, value: 18400, label: 'Hair Services' },
  { id: 1, value: 12200, label: 'Wig Sales' },
  { id: 2, value: 7800,  label: 'Wig Repairs' },
  { id: 3, value: 5100,  label: 'Color Treatments' },
  { id: 4, value: 3300,  label: 'Products' },
];

export default function RevenuePieChart({
  data = revenueData,
  additionalInfoLabel,
  categorySelect = () => {},
  colors = DEFAULT_COLORS,
}) {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ position: 'relative', flexShrink: 0 }}>
        <PieChart
          colors={colors}
          hideLegend={true}
          series={[
            {
              data,
              innerRadius: 60,
              outerRadius: 120,
              paddingAngle: 2,
              cornerRadius: 4,
              cx: 150,
              cy: 150,
              highlightScope: { fade: 'global', highlight: 'item' },
              valueFormatter: (item) =>
                `$${item.value.toLocaleString()} (${Math.round((item.value / total) * 100)}%)`,
            },
          ]}
          width={320}
          height={300}
          slotProps={{ legend: { hidden: true } }}
          tooltip={{ trigger: 'item' }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: 151,
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            cursor: 'pointer',
          }}
          onClick={() => categorySelect(null)}
        >
          <Typography variant="caption" color="text.secondary" display="block">
            Total
          </Typography>
          <Typography variant="h6" fontWeight={500}>
            ${total.toLocaleString()}
          </Typography>
        </Box>
      </Box>

      <LegendList>
        {data.map((item, idx) => (
          <LegendRow key={item.id} onClick={() => categorySelect(item)}>
            <Swatch color={colors[idx % colors.length]} />
            <LabelBlock>
              <Title>{item.label}</Title>
              <Subheader>
                {additionalInfoLabel ? additionalInfoLabel(item, total) : null}
              </Subheader>
            </LabelBlock>
          </LegendRow>
        ))}
      </LegendList>
    </Box>
  );
}